var _circle, _circle2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboardFacilityIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#1479FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#1479FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9_25272)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.75 13.75H21.25V12.25H19.75V13.75ZM19.75 16.75H21.25V15.25H19.75V16.75ZM19.75 19.75H21.25V18.25H19.75V19.75ZM19.75 22.75V21.25H22.75V10.75H16V11.8L14.5 10.7125V9.25H24.25V22.75H19.75ZM7.75 22.75V15.25L13 11.5L18.25 15.25V22.75H13.75V19H12.25V22.75H7.75ZM9.25 21.25H10.75V17.5H15.25V21.25H16.75V16L13 13.3375L9.25 16V21.25Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardFacilityIcon);
export default __webpack_public_path__ + "static/media/dashboard-facility-icon.e2d22fb70e3286b12f349192ac08fc5c.svg";
export { ForwardRef as ReactComponent };